module.exports = __webpack_public_path__ + "static/media/banner-3-novo2-2024.e0788a7d.jpg";